import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { AlertKeysEnum, type AlertKey } from "@tfg/types/constants/alerts"

type GetAlertMessage = (alertKey: AlertKey) => string

export const useAlertMessage = (): GetAlertMessage => {
  const { t } = useTranslation(["home"])

  const getAlertMessage = useCallback(
    (alertKey: AlertKey): string => {
      switch (alertKey) {
        case AlertKeysEnum.INCOMING_LAUNCH_DATE:
          return t("notifications.alerts.descriptions.incomingLaunchDate")
        case AlertKeysEnum.EXPIRED_LAUNCH_DATE:
          return t("notifications.alerts.descriptions.expiredLaunchDate")
        default:
          return ""
      }
    },
    [t]
  )

  return getAlertMessage
}
